import { render, staticRenderFns } from "./IconImportFile.vue?vue&type=template&id=9271eeac&scoped=true&"
import script from "./IconImportFile.vue?vue&type=script&lang=js&"
export * from "./IconImportFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9271eeac",
  null
  
)

export default component.exports